import React, { Component, Fragment } from 'react';
import { Translate } from 'react-redux-i18n';

import { css } from 'aphrodite/no-important';
import styles from './DataTable.styles';
import { accessColumnData } from '../../../utils/transform';
import { FILTER_TYPE } from '../../../constants/data';

import DataTableGroup from './datatablegroup/DataTableGroup';
import DateBar from '../../common/datebar/DateBar';
import Dropdown from '../../common/dropdown/Dropdown';
import FilterBar from '../filterbar/FilterBar';
import SearchInput from '../../inputs/searchinput/SearchInput';
import Button from '../../inputs/button/Button';
import Icon from '../../../components/common/icon/Icon';

class DataTable extends Component {
  state = {
    selection: [],
    areAllSelected: false,
    isSearching: false,
    searchValue: '',
    margin: false
  };
  componentDidUpdate() {
    let margin = this.refs.body.clientHeight !== this.refs.body.scrollHeight;
    if (margin !== this.state.margin) {
      this.setState({ margin });
    }
  }

  componentWillReceiveProps(props) {
    const { scrollToTopToggle } = this.props;
    if (props.scrollToTopToggle !== scrollToTopToggle) {
      this.refs.body.scrollTo(0, 0);
    }
  }

  toggleSelection = key => {
    let selection = [...this.state.selection];
    const keyIndex = selection.indexOf(key);
    let areAllSelected = this.state.areAllSelected;
    // check to see if the key exists
    if (keyIndex >= 0) {
      selection.splice(keyIndex, 1);
      areAllSelected = false;
    } else {
      selection.push(key);
    }
    this.setState({ selection, areAllSelected });
  };

  toggleAll = () => {
    let selection = [];
    if (!this.state.areAllSelected) {
      if (this.props.isDataGrouped) {
        selection = Object.keys(this.props.data)
          .map(key => this.props.data[key])
          .reduce(
            (ids, group) => [...ids, ...group.items.map(tag => tag.id)],
            []
          );
      } else {
        selection = this.props.data.map(item => item.id);
      }
    }
    this.setState({ areAllSelected: !this.state.areAllSelected, selection });
  };

  isSelected = key => {
    return this.state.selection.includes(key);
  };

  openSearch = () => {
    this.setState({ isSearching: true, searchValue: '' });
  };

  closeSearch = () => {
    this.setState({ isSearching: false, searchValue: '' });
  };

  handleSearchChange = e => {
    this.setState({ searchValue: e.currentTarget.value });
  };

  addFilter = (value, column, accessor, type = FILTER_TYPE.SEARCH, sortField) => {
    this.props.addFilter({ type, column, accessor, value, sortField });
  };

  removeFilter = filter => {
    this.props.removeFilter(filter);
  };

  onSort = (column) => {
    this.props.onSort({ column });
  };

  handleSearch = e => {
    if ((e.charCode || e.keyCode) === 13) {
      this.state.searchValue
        .split(' ')
        .filter(Boolean)
        .forEach(value => this.addFilter(value));
      this.setState({ searchValue: '' });
    }
  };
  handleExportClick = e =>{
    this.props.onExport();
  };

  onDropdownOpen = (column) => {
    this.props.onFilterOpen && this.props.onFilterOpen(column);
  }

  renderHeader = () => {
      const { listView, onEdit, onRefresh } = this.props;
      return (
        <div>
        <div className={css(styles.toolBar)}>
        {!listView && (<Button
              styles={[
                styles.button
              ]}
              onClick={this.props.goToListView}
            >
              <Translate value="list" />
            </Button>)}
            {listView && (<Button
              styles={[
                styles.button
              ]}
              onClick={this.props.goToMapView}
            >
              <Translate value="map" />
            </Button>)}
          <SearchInput
              styles={{
                base: styles.searchBase,
                input: styles.searchInput,
                icon: styles.searchInputIcon
              }}
              onChange={this.handleSearchChange}
              onKeyPress={this.handleSearch}
              value={this.state.searchValue}
            />
          {typeof this.props.tagsCount === 'number' ?
            (<div className={css(styles.count)}>
              <span>
                Total Tags: {this.props.tagsCount}
                </span>
            </div>) :
            null
          }
            {onRefresh && (<Button
              styles={[
                styles.button
              ]}
              onClick={onRefresh}
            >
              <Icon
                value="redo"
                styles={styles.icon}
              />
              <Translate value="data.refresh" />
            </Button>)}
            <Button
              styles={[
                styles.button
              ]}
              onClick={this.handleExportClick}
            >
              <Translate value="data.export" />
            </Button>
        </div>
        <div className={css(styles.header)}>
        <div
          className={css(
            styles.header,
            this.state.margin && styles.headerMargin
          )}
        >
          <div className={css(styles.headerCell, styles.select)}>
          </div>
          {this.props.columns.filter(c=>!c.hidden).map(this.renderTh)}
          {onEdit && (<div className={css(styles.search)}/>)}
          </div>
        </div>
        </div>
      );
    };

  renderTh = (column, index) => {
    const { data, isDataGrouped, onSort, sorting } = this.props;
    if(!column.allowFilter && !column.allowSort){
      return(
        <div
        className={css(styles.headerCell)}
        key={index}
        style={{ width: `${100 / this.props.columns.length}%` }}
      >{column.Header}</div>
      )
    }
    let items = isDataGrouped
      ? Object.keys(data).reduce(
          (result, key) => [...result, ...data[key].items],
          []
        )
      : data;
    let options = column.allowFilter
      ? (column.hasCustomFilterValues ? column.customFilterValues : Array.from(
        new Set(
          items.map(item => accessColumnData(item, column)).filter(Boolean)
        )
      )).sort(function (value1, value2) {
        return value1.localeCompare(value2, 'en-US', { numeric: true, sensitivity: 'base' });
      })
      : [];
    let selected = sorting && sorting.column && sorting.column.sortField === column.sortField;
    let reverse = sorting && sorting.descendingOrder;
    return (
      <div
        className={css(styles.headerCell)}
        key={index}
        style={{ width: `${100 / this.props.columns.length}%` }}
      >
        <Dropdown
          isCompact={true}
          showSearch={true}
          showIcon={column.allowSort}
          showMenu={!!options.length && column.allowFilter}
          onSelect={value =>
            this.addFilter(
              value,
              column.Header,
              column.accessor,
              FILTER_TYPE.COLUMN,
              column.sortField
            )
          }
          onDropdownOpen={this.onDropdownOpen.bind(this, column)}
          onIconClick={ onSort && (() => this.onSort(column)) }
          value={column.Header}
          options={options.map(option => ({ name: option, value: option }))}
          sortSelected={selected}
          sortReverse={reverse}
        />
      </div>
    );
  };

  filterEmptyGroups = (group) => {
    // Only exclude empty Groups when any is filter is applied
    if (this.props.filteredBy && this.props.filteredBy.length && !(group.items && group.items.length)) {
      return false;
    }
    return true;
  }

  renderGroup = (group, index) => {
    return (
      <DataTableGroup
        key={index}
        name={group.name}
        data={group.items}
        columns={this.props.columns.filter(c=>!c.hidden)}
        showGroupHeader={true}
        isSelected={this.isSelected}
        toggleSelection={this.toggleSelection}
        onRowClick={this.props.onRowClick}
        onRowExpand={this.props.onRowExpand}
        selectedRow={this.props.selectedRow}
        onEdit={this.props.onEdit}
        showHistory={this.props.showHistory}
        filters={this.props.filteredBy}
      />
    );
  };

  renderDefaultGroup = group => {
    return (
      <DataTableGroup
        name={group.name}
        data={group.items}
        columns={this.props.columns.filter(c=>!c.hidden)}
        showGroupHeader={false}
        isSelected={this.isSelected}
        toggleSelection={this.toggleSelection}
        onRowClick={this.props.onRowClick}
        onRowExpand={this.props.onRowExpand}
        selectedRow={this.props.selectedRow}
        onEdit={this.props.onEdit}
        showHistory={this.props.showHistory}
      />
    );
  };

  render() {
    if (!this.props.columns) {
      return <div className={css(styles.base, this.props.styles)} />;
    }
    let { data, selected, isDataGrouped } = this.props;
    let defaultGroup = isDataGrouped
      ? selected in data
        ? data[selected]
        : {}
      : { items: data };
    let remainingGroupKeys = isDataGrouped
      ? Object.keys(data).filter(key => key !== selected)
      : [];
    return (
      <Fragment>
        {!!this.state.selection.length && (
          <DateBar
            handleClick={(start, end) =>
              this.props.onHistoryDownload(this.state.selection, start, end)
            }
            buttonText="download"
          />
        )}
        {!!this.props.filteredBy.length && (
          <FilterBar
            items={this.props.filteredBy}
            onRemove={this.removeFilter}
          />
        )}
        
        <div className={css(styles.base, this.props.styles)}>
          {this.renderHeader()}
          {
            <div className={css(styles.body)} ref="body">
              {this.renderDefaultGroup(defaultGroup)}
              {isDataGrouped &&
                remainingGroupKeys
                  .map(key => this.props.data[key])
                  .filter(this.filterEmptyGroups)
                  .map(this.renderGroup)}
            </div>
          }
        </div>
      </Fragment>
    );
  }
}

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/data/datatable/DataTable.js